const isValidPromptSearchTerm = (searchTerm: string): boolean => {
	return !(
		hasUnderscore(searchTerm) ||
		isAnwTrack(searchTerm) ||
		isAnwAlbum(searchTerm) ||
		isMusicFile(searchTerm) ||
		isUrl(searchTerm)
	)
}

// Original regex imported from previous search
const isAnwTrack = (searchTerm: string): boolean => {
	const regex = /^ANW\d+(?:[_/]\d*[_\w-]*)?(?:\.[a-zA-Z0-9]+)?$/i
	return regex.test(searchTerm)
}

// Additional regex to prevent more anw based searches
const isAnwAlbum = (searchTerm: string): boolean => {
	const regex = /^ANW([^a-zA-Z].*)?$/i

	return regex.test(searchTerm)
}

// Additional regex to prevent more anw based searches
const isMusicFile = (searchTerm: string): boolean => {
	const regex = /\b[\w,\s-]+\.(wav|mp3|aiff)\b/i

	return regex.test(searchTerm)
}

// Exclude urls
const isUrl = (searchTerm: string): boolean => {
	const regex = /https?:\/\/[^\s/$.?#].[^\s]*|[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+/g

	//const regex = /https?:\/\/[^\s/$.?#].[^\s]*/g

	return regex.test(searchTerm)
}

// Exclude underscores
const hasUnderscore = (searchTerm: string): boolean => {
	const regex = /_/

	//const regex = /https?:\/\/[^\s/$.?#].[^\s]*/g

	return regex.test(searchTerm)
}

export default isValidPromptSearchTerm
